import { Languages } from '../../model/types';
import { isSSR } from '../helpers';
import { getLocalStorageItem, setLocalStorageItem, StorageHelperKeys } from '../storageHelpers';

function changeLanguageToBrowserDefault() {
    // ! firefox does not give language information from his settings
    const browserDefaultLanguage = navigator.language.split('-')[0].toUpperCase() as Languages;
    changeLanguageOnLocalStorage(browserDefaultLanguage);
}

const changeLanguageOnLocalStorage = (language: Languages) => setLocalStorageItem(StorageHelperKeys.LNG, language);

function getClientSideLanguage(): Languages {
    const clientSideLanguage: Languages = getLocalStorageItem(StorageHelperKeys.LNG);
    if (!clientSideLanguage) {
        changeLanguageToBrowserDefault();
        return getClientSideLanguage();
    }
    return clientSideLanguage;
}

const getDefaultLanguage = () => (isSSR() ? Languages.EN : getClientSideLanguage());

export { changeLanguageOnLocalStorage, getClientSideLanguage, getDefaultLanguage };
